'use client'

import { useIsPurMode } from '@/hooks/useIsPurMode'
import { useEffect } from 'react'
import gtmInit from '@/libs/Google/GoogleTagManager.lib'
import AppContext from '@/types/context'

export default function GoogleTagManager({ context }: { readonly context: AppContext }) {
  const isPurMode = useIsPurMode()

  useEffect(() => {
    if (!isPurMode && context?.metadata) {
      gtmInit({
        trackingPath: context.metadata?.model.trackingPath,
        article: context.metadata?.model.article,
        sectionName: context.metadata?.model.sectionName,
        isWebView: context.webview,
        gtmKeywords: context.metadata?.model.gtmKeywords,
      })
    }
  }, [])

  return <></>
}
